export default __webpack_public_path__ + "static/media/sunTtsIt_It60.fb4b53b6.mp3";